import { render, staticRenderFns } from "./SectionLookup.vue?vue&type=template&id=3c1285b6"
import script from "./SectionLookup.vue?vue&type=script&lang=js"
export * from "./SectionLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports